import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { MoreParents } from './components/MoreParents';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    // Adelantar la conexión al checkout para que abra rápido al hacer click
    const addLink = (rel: string, crossOrigin?: boolean) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = 'https://digitalpremium.online';
      if (crossOrigin) link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    };
    addLink('dns-prefetch');
    addLink('preconnect', true);
  }, []);
  useEffect(() => {
    // Cargar el Meta Pixel de forma diferida para no bloquear el render inicial
    const loadPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1670056917527791');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      // noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1670056917527791&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };
    // Esperar a que la página esté inactiva para que aparezca enseguida
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void) => number;
    };
    if (typeof w.requestIdleCallback === 'function') {
      w.requestIdleCallback(loadPixel);
    } else {
      const timer = setTimeout(loadPixel, 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  return <div className="min-h-screen bg-[#07223a] text-slate-200 selection:bg-sky-500 selection:text-white font-sans" data-id="element-0">
      <main className="overflow-hidden" data-id="element-1">
        <Hero data-id="element-2" />
        <Stats data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ProductSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <MoreParents data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <PurchaseNotification data-id="element-11" />
    </div>;
}